export const MenuItem: React.FC<{
  text: string;
  onClick?: () => void;
  href?: string;
  mailTo?: string;
  showNotification?: boolean;
}> = ({ text, onClick, href, mailTo, showNotification = false }) => {
  const isLink = !!href;
  const isMail = !!mailTo;

  const Component = isLink || isMail ? 'a' : 'div';

  // TODO-TM: Improve Notification UI

  return (
    <Component
      href={isLink ? href : isMail ? `mailto:${mailTo}` : undefined}
      onClick={!isLink && !isMail ? onClick : undefined}
      className='my-[30px] font-bold text-[16px] leading-[20px] no-underline cursor-pointer flex flex-row justify-start items-center gap-2'
      style={{ color: 'black', display: 'block', textDecoration: 'none' }}
      target={isLink || isMail ? '_blank' : undefined} // Open PDFs in a new tab
      rel={isLink ? 'noopener noreferrer' : undefined}
    >
      <div className="absolute">{showNotification && <div className='w-2 h-2 bg-holifya-red rounded-full' />}</div>
      <div>{text}</div>
    </Component>
  );
};
